var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStationarytestingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #eef8ff;\n        stroke-linecap: square;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "engine",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10883",
    "data-name": "Group 10883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6913",
    "data-name": "Path 6913",
    className: "cls-1",
    d: "M19,22H1V8H13l3,4h3Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8165",
    "data-name": "Line 8165",
    className: "cls-1",
    y2: 6,
    transform: "translate(23 14)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8166",
    "data-name": "Line 8166",
    className: "cls-1",
    x2: 8,
    transform: "translate(3 2)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8167",
    "data-name": "Line 8167",
    className: "cls-1",
    x1: 4,
    transform: "translate(19 17)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8168",
    "data-name": "Line 8168",
    className: "cls-1",
    y1: 2,
    transform: "translate(7 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationarytestingicon);
export default __webpack_public_path__ + "static/media/stationarytestingicon.1d75e8653c38ba6279eeaf41e76813fb.svg";
export { ForwardRef as ReactComponent };